import React, { Component } from "react";
import { Container, Form, Button, Card, Spinner } from "react-bootstrap";
import './Images.css';

import { Configuration, OpenAIApi } from 'openai'; 

const configuration = new Configuration({
    apiKey: process.env.REACT_APP_OPENAI_API_KEY
});
const openai = new OpenAIApi(configuration);

class Images extends Component {
    constructor() {
        super();
        this.state = {
            heading: "The image will appear here",
            response: "...creating image...",
            size: "large",
            generatedText: "I like to think...",
            isLoadingText: false,
            isLoadingImage: false
        };
    }

    onFormSubmit = (e) => {
        e.preventDefault();
        this.setState({ isLoadingText: true });

       
      

        openai.createCompletion({
           
                model: "text-davinci-003",
                prompt: 
                `Create a the 4th stanza for 
                All Watched Over By Machines Of Loving Grace, by Richard Brautigan, here is the whole poem, follow the same format:
               
                I like to think (and
                the sooner the better!)
                of a cybernetic meadow
                where mammals and computers
                live together in mutually
                programming harmony
                like pure water
                touching clear sky.

                I like to think
                (right now, please!)
                of a cybernetic forest
                filled with pines and electronics
                where deer stroll peacefully
                past computers
                as if they were flowers
                with spinning blossoms.
              
                I like to think
                (it has to be!)
                of a cybernetic ecology
                where we are free of our labors
                and joined back to nature,
                returned to our mammal
                brothers and sisters,
                and all watched over
                by machines of loving grace.
                
                y then add your stanza here includding at least one new tech, combing nature and tech, be very creative`,
              
                
                temperature: 0.9,
                max_tokens: 300,
                top_p: 1,
                frequency_penalty: 0,
                presence_penalty: 0,
               
            }).then((response) => {
                this.setState({
                    generatedText: `${response.data.choices[0].text}`,
                    isLoadingText: false,
                }, () => {
                    this.setState({ isLoadingImage: true });
                    openai.createImage({
                    prompt: `60s aesthetics, psychedelic, peace and love ${response.data.choices[0].text}`,
                    n: 1,
                    size: this.state.size === "large" ? "1024x1024" : this.state.size === "medium" ? "512x512" : "256x256",
                }).then((response) => {
                    this.setState({
                      
                        response: `${response.data.data[0].url}`,
                        isLoadingImage: false
                    });
                }).catch((error) => {
                    console.log(error);
                });
            });
        }).catch((error) => {
            console.log(error);
        });
    }

    handleSizeChange = (e) => {
        this.setState({ size: e.target.value });
    }

    render() {
        return (
            <div className="images">
                 
                <Container className="images-container">
                <h2>Derivative Techno-Utopias</h2>
                   
                    <p className="subtitle-text">
                    "Derivative Techno-Utopias" uses AI to foreground the persistently recycled narratives of techno-utopias, steeped in the boundless optimism characteristic of Californian tech idealism merging notion of nature with digital technologies. Genrative AI is used to create the fourth stanza for the 1967 counterculture
                    seminal poem <b>"All Watched Over By Machines Of Loving Grace" </b> by 
                  <a target="_blank" rel="noreferrer" href="https://allpoetry.com/All-Watched-Over-By-Machines-Of-Loving-Grace"> Richard Brautigan.</a>. A stanza is generated in Braitigan's style and also an image reflecting the text and constructed following the aesthetics of the times. "Derivative Techno-Utopias" celebrates literary and technological visions while prompting critical reflection on the allure and pitfalls of continually recycling and uncritically embracing utopian instantiations of the merging of cybernetic visions with 1960's counterculture.
                    </p>
                    <Form onSubmit={this.onFormSubmit} className="form-inline">
    <Form.Group controlId="formSize" className="form-group">
       
    </Form.Group>
    <Button className="vintage-button" type="submit">Generate</Button>

</Form>

                    <Card className="images-card rounded-card">
                        <Card.Body>
                            <Card.Text className="images-text">
                                {this.state.isLoadingText ? (
                                    <Spinner animation="border" role="status">
                                        <span className="sr-only"><div class="lds-hourglass"></div></span>
                                    </Spinner>
                                ) : (
                                    <p className="generated-text">{this.state.generatedText}</p>
                                )}
                                {this.state.isLoadingImage ? (
                                    <Spinner animation="border" role="status">
                                        <span className="sr-only"><div class="lds-hourglass"></div></span>
                                    </Spinner>
                                ) : (
                                    <div className="image-wrapper">
                                        <a 
                                            className="image-link"
                                            download="artifact"
                                            rel="noreferrer"
                                            href={this.state.response}
                                            target="_blank">
                                          <img 
    className={`generated-image ${this.state.isLoadingImage ? '' : 'loaded'}`} 
    src={this.state.response} 
    alt=''/>
                                        </a>
                                    </div>
                                )}
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Container>
            </div>
        );
    }
}

export default Images;